import NiceModal from "@ebay/nice-modal-react";
import AddressKrModal from "modals/address/kr/AddressKrModal";
import PaymentCompleteModal from "./PaymentCompleteModal";
import PaymentModal from "./PaymentModal";
import ReceiptDetailModal from "modals/receipt/ReceiptDetailModal";
import ConfirmModal from "modals/confirm/ConfirmModal";
import PaymentRequestModal from "modals/payment/PaymentRequestModal";
import LogoutConfirmModal from "modals/confirm/LogoutConfirmModal";
import ShippingInfoAddKrModal from "modals/shippingInfo/ShippingInfoAddKrModal";
import ItemDispensingModal from "modals/waiting/ItemDispensingModal";
import WaitForItemCollectionModal from "modals/waiting/WaitForItemCollectionModal";
import PurchaseOrderModal from "modals/order/PurchaseOrderModal";
import WaitingForProductsModal from "modals/waiting/WaitingForProductsModal";

import TestPuffuOrderModal from "./TestPuffuOrderModal";
import TestPaymentModal from "./TestPaymentModal";
import NumberVerificationModal from "modals/confirm/NumberVerificationModal";
import NumberVerificationByPaymentModal from "modals/confirm/NumberVerificationByPaymentModal";
import NumberVerificationByPuffuOrderModal from "modals/confirm/NumberVerificationByPuffuOrderModal";
import StoreListModal from "modals/store/StoreListModal";
import StoreDetailModal from "modals/store/StoreDetailModal";
import StoreManagementDetailModal from "routes/admin/store/StoreManagementDetailModal";
import PartnersRecentPaymentHistoryModal from "routes/partners/sales/PartnersRecentPaymentHistoryModal";
import StoreItemStockModal from "routes/admin/dashboardCard/statistics/StoreItemStockModal";
import AddProductToStoreModal from "routes/admin/store/AddProductToStoreModal";

function ModalHandler() {
  NiceModal.register("payment", PaymentModal);
  NiceModal.register("testPayment", TestPaymentModal);
  NiceModal.register("paymentRequest", PaymentRequestModal);
  NiceModal.register("paymentComplete", PaymentCompleteModal);
  NiceModal.register("addressKr", AddressKrModal);
  NiceModal.register("receiptDetail", ReceiptDetailModal);
  NiceModal.register("confirm", ConfirmModal);
  NiceModal.register("numberVerification", NumberVerificationModal);
  NiceModal.register("numberVerificationByPayment", NumberVerificationByPaymentModal);
  NiceModal.register("numberVerificationByPuffuOrder", NumberVerificationByPuffuOrderModal);  
  NiceModal.register("logout", LogoutConfirmModal);
  NiceModal.register("shippingInfoAddKrModal", ShippingInfoAddKrModal);
  NiceModal.register("itemDispensing", ItemDispensingModal);
  NiceModal.register("purchaseOrder", PurchaseOrderModal);
  NiceModal.register("waitForItemCollection", WaitForItemCollectionModal);
  NiceModal.register("waitingForProducts", WaitingForProductsModal);
  NiceModal.register("puffuOrder", TestPuffuOrderModal);
  NiceModal.register("storeList", StoreListModal);
  NiceModal.register("storeDetail", StoreDetailModal);
  NiceModal.register("storeManagementDetail", StoreManagementDetailModal);
  NiceModal.register("partnersRecentPaymentHistory", PartnersRecentPaymentHistoryModal);
  NiceModal.register("storeItemStockModal", StoreItemStockModal);
  NiceModal.register("addProductToStoreModal", AddProductToStoreModal);


}

export default ModalHandler;
